interface Config {
  apiBaseUrl: string;
  posthog: {
    key: string;
    host: string;
  };
  sentry: {
    dsn: string;
    environment: string;
  };
}

// Resolve the API base. When VITE_API_URL is a RELATIVE path (e.g. "/api"),
// anchor it to the current origin so the same build serves any domain it's
// deployed on (marketing site + the operator app on its own domain) and always
// talks to its own backend. Absolute values (prod's old full URL, the
// localhost dev default) pass through unchanged, so the socket code that reads
// `new URL(apiBaseUrl).origin` keeps working.
const rawApiBase = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const resolvedApiBase =
  rawApiBase.startsWith('/') && typeof window !== 'undefined'
    ? `${window.location.origin}${rawApiBase}`
    : rawApiBase;

const config: Config = {
  apiBaseUrl: resolvedApiBase,
  posthog: {
    key: import.meta.env.VITE_POSTHOG_KEY || '',
    host: import.meta.env.VITE_POSTHOG_HOST || 'https://us.i.posthog.com',
  },
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment: import.meta.env.MODE || 'development',
  },
};

export default config;
